import { cdnSources } from './config/index';
const CONFIG = {
    version: 6,
    autoRun: true,
    ignoreDefaultSources: true,
    cdnSources,
    duration: 60000,
};
export default CONFIG;
//# sourceMappingURL=config.js.map